// Review cards loop endlessly once they outnumber the visible columns
(function () {
  const perViewFor = (columns) => (window.innerWidth >= 990 ? columns : window.innerWidth >= 750 ? 2 : 1);

  const build = (slider) => {
    const wrapper = slider.querySelector('.swiper-wrapper');
    const section = slider.closest('.testimonials');
    const columns = parseInt(slider.dataset.columns, 10) || 3;
    wrapper.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
    const cards = Array.from(wrapper.children);
    slider.dataset.perView = perViewFor(columns);
    const perView = Math.ceil(perViewFor(columns));
    const loop = cards.length > perViewFor(columns);

    // Loop needs spare slides beyond one view; repeat the set until there are enough
    while (loop && wrapper.children.length < perView * 2 + 1) {
      cards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        wrapper.appendChild(clone);
      });
    }

    new Swiper(slider, {
      loop,
      a11y: false,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        750: { slidesPerView: 2, spaceBetween: 24 },
        990: { slidesPerView: columns, spaceBetween: 24 },
      },
      navigation: {
        prevEl: section.querySelector('.testimonials__prev'),
        nextEl: section.querySelector('.testimonials__next'),
      },
    });
  };

  const init = () => {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.testimonials__slider').forEach((slider) => {
      if (!slider.swiper) build(slider);
    });
  };

  // Rebuild when a resize changes how many cards fit
  let timer;
  window.addEventListener('resize', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      document.querySelectorAll('.testimonials__slider').forEach((slider) => {
        if (!slider.swiper) return;
        if (String(perViewFor(parseInt(slider.dataset.columns, 10) || 3)) === slider.dataset.perView) return;
        slider.swiper.destroy(true, true);
        build(slider);
      });
    }, 200);
  });

  init();
  document.addEventListener('shopify:section:load', init);

  // Theme editor: bring the selected review into view
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('.testimonials__card');
    const slider = card && card.closest('.testimonials__slider');
    if (slider && slider.swiper) slider.swiper.slideToLoop(Array.from(card.parentElement.children).indexOf(card));
  });
})();
